"use client"

import { Button } from "@/components/ui/button"
import { LeoSwapIcon } from "@/components/ui/leo-swap-icon"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export function QuestionLeoAlterMenu({
  questionNumber,
  disabled = false,
  onRewrite,
  onReplace,
  onPickFromBank,
  size = "icon-xs",
  menuClassName,
}: {
  questionNumber: number
  disabled?: boolean
  onRewrite?: () => void
  onReplace?: () => void
  /** Author swaps this slot themselves, from the bank. */
  onPickFromBank?: () => void
  /** Sheet toolbar uses the same size as the other icon buttons. */
  size?: "icon-xs" | "icon-sm"
  /** Lift the menu above a floating sheet. */
  menuClassName?: string
}) {
  if (!onRewrite && !onReplace && !onPickFromBank) return null
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size={size}
          disabled={disabled}
          aria-label={`Rewrite or replace question ${questionNumber}`}
          aria-haspopup="menu"
          onClick={(event) => event.stopPropagation()}
          onPointerDown={(event) => event.stopPropagation()}
        >
          <i className="fa-light fa-arrows-rotate" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className={menuClassName}
        onCloseAutoFocus={(event) => event.preventDefault()}
      >
        {onRewrite ? (
          <DropdownMenuItem
            onSelect={(event) => {
              event.preventDefault()
              onRewrite()
            }}
          >
            <i className="fa-duotone fa-solid fa-star-christmas text-brand" aria-hidden />
            Enhance with Leo
          </DropdownMenuItem>
        ) : null}
        {onReplace ? (
          <DropdownMenuItem
            onSelect={(event) => {
              event.preventDefault()
              onReplace()
            }}
          >
            <LeoSwapIcon />
            Replace with a better match
          </DropdownMenuItem>
        ) : null}
        {onPickFromBank ? (
          <DropdownMenuItem
            onSelect={(event) => {
              event.preventDefault()
              onPickFromBank()
            }}
          >
            <i className="fa-light fa-books" aria-hidden />
            Pick from bank
          </DropdownMenuItem>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
